import ApiClient from '../client';
import Config from '../../services/config.service';
const config = new Config();
const path = require('path');

class UsergroupAPI extends ApiClient {

  userstatus=undefined;
  
  usergroupStatuses=undefined;

  userGroupRoles=undefined;

  constructor() {
    super();
  }

  async getUsergroupsList(usergroupTypes, page = 1, filters) {
    let route = path.join(
      this.USERGROUP_API_PATH,
      `user-groups/?page_size=${config.itemsPerPage.usergroups}&page=${page}`
    );
    if (usergroupTypes.length > 0) {
      route = route.concat('', `${route.includes('?') ? '&' : '?'}usergroup_type=${usergroupTypes.join(',')}`);
    }
    if (filters) {
      for (const filter in filters) {
        if (filters[filter] && filters[filter].length) {
          route = route.concat('', `${route.includes('?') ? '&' : '?'}${filter}=${filters[filter].join(',')}`);
        }
      }
    }
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async orderUsergroupsList(direction, field, usergroupTypes, filters, page = 1) {
    let route = path.join(
      this.USERGROUP_API_PATH,
      `user-groups/?page_size=${config.itemsPerPage.usergroups}&page=${page}&ordering=${direction}${field}`
    );
    if (usergroupTypes.length > 0) {
      route = route.concat('', `${route.includes('?') ? '&' : '?'}usergroup_type=${usergroupTypes.join(',')}`);
    }
    if (filters) {
      for (const filter in filters) {
        if (filters[filter] && filters[filter].length) {
          route = route.concat('', `${route.includes('?') ? '&' : '?'}${filter}=${filters[filter].join(',')}`);
        }
      }
    }
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async getFilteredUsergroupsList(type, page = 1, filters) {
    let route = path.join(
      this.USERGROUP_API_PATH,
      `user-groups/?page_size=${config.itemsPerPage.usergroups}&page=${page}&usergroup_type=${type}`
    );
    if (filters) {
      for (const filter in filters) {
        if (filters[filter] && filters[filter].length) {
          route = route.concat('', `${route.includes('?') ? '&' : '?'}${filter}=${filters[filter].join(',')}`);
        }
      }
    }
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async orderFilteredUsergroupsList(direction, field, type, page = 1, filters) {
    let route = path.join(
      this.USERGROUP_API_PATH,
      `user-groups/?page_size=${config.itemsPerPage.usergroups}&page=${page}&ordering=${direction}${field}&usergroup_type=${type}`
    );
    if (filters) {
      for (const filter in filters) {
        if (filters[filter] && filters[filter].length) {
          route = route.concat('', `${route.includes('?') ? '&' : '?'}${filter}=${filters[filter].join(',')}`);
        }
      }
    }
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async getUsergroup(id) {
    const route = path.join(
      this.USERGROUP_API_PATH,
      `user-groups/${id}/`
    );
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async createUsergroup(data) {
    const route = path.join(
      this.USERGROUP_API_PATH,
      'user-groups/'
    );
    const response = await this.post(route, data);
    if (response.status === 201) {
      return response.data;
    }
    return false;
  }

  async updateUsergroup(id, data) {
    const route = path.join(
      this.USERGROUP_API_PATH,
      `user-groups/${id}/`
    );
    const response = await this.put(route, data);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async patchUsergroup(id, data) {
    const route = path.join(
      this.USERGROUP_API_PATH,
      `user-groups/${id}/`
    );
    const response = await this.patch(route, data);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async deleteUsergroup(id) {
    const route = path.join(
      this.USERGROUP_API_PATH,
      `user-groups/${id}/`
    );
    const response = await this.delete(route);
    if (response.status === 204) {
      return response.data;
    }
    return false;
  }

  // PARENTS
  async getUsergroupParents(usergroupId, direction, field) {
    let route;
    if (field) {
      route = path.join(
        this.USERGROUP_API_PATH,
        `user-groups/${usergroupId}/parents/?ordering=${direction}${field}`
      );
    } else {
      route = path.join(
        this.USERGROUP_API_PATH,
        `user-groups/${usergroupId}/parents/`
      );
    }
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }
  async addUsergroupParent(usergroupId, parentId) {
    const route = path.join(
      this.USERGROUP_API_PATH,
      `user-groups/${usergroupId}/parents/`
    );
    const response = this.post(
      route,
      { parent_id: parentId }
    );
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }
  async removeUsergroupParent(usergroupId, parentId) {
    const route = path.join(
      this.USERGROUP_API_PATH,
      `user-groups/${usergroupId}/parents/${parentId}/`
    );
    const response = this.delete(route, );
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }
  // CHILDREN
  async getUsergroupChildren(usergroupId, direction, field) {
    let route;
    if (field) {
      route = path.join(
        this.USERGROUP_API_PATH,
        `user-groups/${usergroupId}/children/?ordering=${direction}${field}`
      );
    } else {
      route = path.join(
        this.USERGROUP_API_PATH,
        `user-groups/${usergroupId}/children/`
      );
    }
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }
  async addUsergroupChild(usergroupId, childId) {
    const route = path.join(
      this.USERGROUP_API_PATH,
      `user-groups/${usergroupId}/children/`
    );
    const response = this.post(
      route,
      { child_id: childId }
    );
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }
  async removeUsergroupChild(usergroupId, childId) {
    const route = path.join(
      this.USERGROUP_API_PATH,
      `user-groups/${usergroupId}/children/${childId}/`
    );
    const response = this.delete(route, );
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async getUsergroupRoles() {
    if(this.userGroupRoles){
      return this.userGroupRoles;
    }
    const route = path.join(
      this.USERGROUP_API_PATH,
      'user-group-roles/'
    );
    const response = await this.get(route);
    if (response.status === 200) {
      this.userGroupRoles=response.data;
      return response.data;
    }
    return false;
  }

  // USERGROUP MEMBERS
  async getUsergroupMembers(id, direction, field, page = 1) {
    let route = path.join(
      this.USERGROUP_API_PATH,
      `user-groups/${id}/members/?page_size=${config.itemsPerPage.usergroupMembers}&page=${page}`
    );
    if (field) {
      route = route.concat('', `&ordering=${direction}${field}`);
    }
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }
  async addUsergroupMember(usergroupId, data) {
    const route = path.join(
      this.USERGROUP_API_PATH,
      `user-groups/${usergroupId}/members/`
    );
    const response = await this.post(route, data);
    return response;
  }
  async updateUsergroupMember(usergroupId, userId, data) {
    const route = path.join(
      this.USERGROUP_API_PATH,
      `user-groups/${usergroupId}/members/${userId}/`
    );
    const response = await this.put(route, data);
    return response;
  }
  async removeUsergroupMember(usergroupId, userId) {
    const route = path.join(
      this.USERGROUP_API_PATH,
      `user-groups/${usergroupId}/members/${userId}/`
    );
    const response = await this.delete(route);
    return response;
  }

  // USERGROUP STATUSES
  async getUserStatuses() {
    if(this.userstatus){
      return this.userstatus;
    }
    try {
      const route = path.join(
        this.USERGROUP_API_PATH,
        'user-status/'
      );
      const response = await this.get(route);
      if (response.status === 200) {
        this.userstatus=response.data;
        return response.data;
      }
      return false;
    } catch {
      return false;
    }
  }
  async getUsergroupStatuses() {
    if(this.usergroupStatuses){
      return this.userstatus;
    }
    try {
      const route = path.join(
        this.USERGROUP_API_PATH,
        'user-group-status/'
      );
      const response = await this.get(route);
      if (response.status === 200) {
        this.usergroupStatuses=response.data;
        return response.data;
      }
      return false;
    } catch {
      return false;
    }
  }

  // USERGROUP THUMBNAIL
  async getUsergroupThumbnail(id) {
    const route = path.join(
      this.USERGROUP_API_PATH,
      `user-groups/${id}/thumbnail/`
    );
    const response = await this.get(route, {
      responseType: 'blob'
    });
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }
  async setUsergroupThumbnail(id, data) {
    const route = path.join(
      this.USERGROUP_API_PATH,
      `user-groups/${id}/thumbnail/`
    );
    const response = await this.put(route, data);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }
  async deleteUsergroupThumbnail(id) {
    const route = path.join(
      this.USERGROUP_API_PATH,
      `user-groups/${id}/thumbnail/`
    );
    const response = await this.delete(route);
    if (response.status === 204) {
      return response.data;
    }
    return false;
  }

  // USERGROUPS ATTACHMENTS
  async getUsergroupAttachments() {
    const route = path.join(
      this.USERGROUP_API_PATH,
      'group-members/?ordering=-date_joined&status__in=0,1'
    );
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }
}

const usergroupAPI = new UsergroupAPI();
export default usergroupAPI;
